import { Epic } from 'redux-observable';
import { switchMap, withLatestFrom, filter } from 'rxjs/operators';
import {
  dashboardViewFetchDashboardRequest,
  dashboardViewInit,
} from '../dashboardViewSlice';
import { RootState } from '../../../../store';

type IN = ReturnType<typeof dashboardViewInit>;
type OUT = ReturnType<typeof dashboardViewFetchDashboardRequest>;

export const DashboardViewInitEpic: Epic<IN | OUT, OUT, RootState> = (
  action$,
  state$,
) =>
  action$.pipe(
    filter(dashboardViewInit.match),
    withLatestFrom(state$),
    switchMap(([, state]) => {
      return [];
      // return [dashboardViewFetchDashboardRequest()];
    }),
  );
